import { useMutation } from "@tanstack/react-query";

import cookiesHelper from "../../helpers/cookies";

import api from "../apiClient";

import { IJobTitle } from "../../interfaces/services";

interface IUseGetAIRecommendationsJobTitles {
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    payload: {
        query: string;
        limit: number;
    },
    successCallback: (data: IJobTitle[]) => void;
}

const useGetAIRecommendations_JobTitles = () => {
    const mutationFn = async (variables: IUseGetAIRecommendationsJobTitles): Promise<IJobTitle[]> => {
        const { query, limit } = variables.payload;

        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get(`/misc/job-titles/ai-recommendations/${query}/${limit}`);
        return response.data;
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (data, variables) => {
            variables.setIsProcessing(false);
            variables.successCallback(data);
        },
        onError: (error, variables) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useGetAIRecommendations_JobTitles;
